// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"71":"d939ff90","197":"cd99d62f","318":"2c8bddd2","640":"3f35a781","709":"60efc24a","746":"16242ea4","762":"df049b44","769":"213bc2d0","852":"93126a7c","879":"a5d39480","996":"e9134be0"}[chunkId] + ".js";
};